import { defineMessages } from 'react-intl';

export default defineMessages({
    explanation: {
        id: '_.iwocaPay.dashboard.approved.overdue.repay_request.explanation',
        defaultMessage:
            'You have an overdue payment of {amount}. Please make a payment or get in touch with us.'
    },
    cta: {
        id: '_.iwocaPay.dashboard.approved.overdue.repay_request.cta',
        defaultMessage: 'Pay now'
    }
});
